// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.wrapper {
    min-height: calc(100vh - 344px);
}

.skip-link-wrapper {
    height: 0;
}

.skip-link-wrapper:focus-within {
    height: auto;
}

.skip-link {
    font-size: 1rem;
    margin: 0.6rem;
    padding: 0.3rem 0.6rem;
    background-color: transparent;
    text-decoration: underline;
    font-weight: bold;
}


@media screen and (min-width: 1537px) {
    .wrapper {
        margin-bottom: 8px;
    }
}

`, "",{"version":3,"sources":["webpack://./src/app/components/app/app.component.css"],"names":[],"mappings":";AACA;IACI,+BAA+B;AACnC;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,sBAAsB;IACtB,6BAA6B;IAC7B,0BAA0B;IAC1B,iBAAiB;AACrB;;;AAGA;IACI;QACI,kBAAkB;IACtB;AACJ","sourcesContent":["\r\n.wrapper {\r\n    min-height: calc(100vh - 344px);\r\n}\r\n\r\n.skip-link-wrapper {\r\n    height: 0;\r\n}\r\n\r\n.skip-link-wrapper:focus-within {\r\n    height: auto;\r\n}\r\n\r\n.skip-link {\r\n    font-size: 1rem;\r\n    margin: 0.6rem;\r\n    padding: 0.3rem 0.6rem;\r\n    background-color: transparent;\r\n    text-decoration: underline;\r\n    font-weight: bold;\r\n}\r\n\r\n\r\n@media screen and (min-width: 1537px) {\r\n    .wrapper {\r\n        margin-bottom: 8px;\r\n    }\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
